import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type {
	GnssVisibilityPerGridpointResponse,
	GnssVisibilityWithSignalsResponse,
} from '@/api/ApiTypes';


const gnssVisibilityBaseStationsGet = (
	subNetworkId: number | null,
	handler: (responseData: GnssVisibilityWithSignalsResponse) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.post('/rinex/get_gnss_visibility/base_stations/', { sub_network: subNetworkId })
		.then(extractData(handler)).catch(errorHandler);
};


const gnssVisibilityGridpointsGet = (
	cnetId: number,
	handler: (responseData: GnssVisibilityPerGridpointResponse) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.post('/rinex/get_gnss_visibility/gridpoints/', { cnet_id: cnetId })
		.then(extractData(handler)).catch(errorHandler);
};


const gnssVisibilitySignalsTableBaseStationGet = (
	baseStationId: number,
	handler: (responseData: GnssVisibilityWithSignalsResponse) => void,
): void => {
	axios.post('/rinex/get_gnss_visibility/signals_table/', { id: baseStationId })
		.then(extractData(handler)).catch(logError);
};


export default {
	gnssVisibilityBaseStationsGet,
	gnssVisibilityGridpointsGet,
	gnssVisibilitySignalsTableBaseStationGet,
};
